export type OrderTier = "standard" | "priority" | "fast";

// Tier values arrive from the API in mixed case on older orders; normalise
// once so comparisons and CSS class names stay exact.
export const normTier = (t: any): OrderTier =>
  typeof t === "string" ? (t.toLowerCase() as OrderTier) : t;
